"use client";import{jsx as e}from"react/jsx-runtime";import{useRef as r,useEffect as t}from"react";import{ButtonContainer as n}from"./Button.parts.js";function o(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function i(e,r){return r=null!=r?r:{},Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):function(e){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var t=Object.getOwnPropertySymbols(e);r.push.apply(r,t)}return r}(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})),e}function c(e,r){if(null==e)return{};var t,n,o=function(e,r){if(null==e)return{};var t,n,o={},i=Object.keys(e);for(n=0;n<i.length;n++)t=i[n],r.indexOf(t)>=0||(o[t]=e[t]);return o}
/**
 * 다양한 스타일과 기능을 제공하는 버튼 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {'button' | 'submit' | 'reset'} [props.type='button'] - 버튼의 타입
 * @param {React.RefObject<HTMLButtonElement>} [props.ref] - 버튼 요소에 대한 ref
 * @param {boolean} [props.disabled=false] - 버튼 비활성화 여부
 * @param {React.ReactNode} props.children - 버튼 내부 콘텐츠
 * @param {string} [props.className] - 추가 CSS 클래스
 * @param {function} [props.onClick] - 클릭 이벤트 핸들러
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - 버튼 크기
 * @param {'outlined' | 'solid' | 'outline_filled'} [props.variant='outlined'] - 버튼 스타일 변형
 * @param {'primary' | 'gray'} [props.color='primary'] - 버튼 색상, outlined 일 때에만 적용 가능
 * @param {boolean} [props.rounded=false] - 둥근 모서리 적용 여부
 * @param {React.ReactNode} [props.leadingIcon] - 버튼 앞쪽 아이콘
 * @param {boolean} [props.isLeadingIconSolid=false] - 앞쪽 아이콘 solid 스타일 적용 여부
 * @param {React.ReactNode} [props.trailingIcon] - 버튼 뒤쪽 아이콘
 * @param {boolean} [props.isTrailingIconSolid=false] - 뒤쪽 아이콘 solid 스타일 적용 여부
 * @param {string | number} [props.badgeNumber=''] - 버튼에 표시될 뱃지 숫자
 * @param {boolean} [props.needThrottle=false] - 쓰로틀링 적용 여부
 *
 * @example
 * // 기본 버튼
 * <Button onClick={() => console.log('클릭됨')}>
 *   버튼
 * </Button>
 *
 * // 아이콘이 있는 비활성화된 버튼
 * <Button
 *   disabled
 *   variant="contained"
 *   leadingIcon={<Icon name="search" />}
 *   size="lg"
 * >
 *   검색
 * </Button>
 *
 * // 쓰로틀링이 적용된 둥근 버튼
 * <Button
 *   rounded
 *   needThrottle
 *   variant="text"
 *   badgeNumber="5"
 *   onClick={handleClick}
 * >
 *   알림
 * </Button>
 */(e,r);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(n=0;n<i.length;n++)t=i[n],r.indexOf(t)>=0||Object.prototype.propertyIsEnumerable.call(e,t)&&(o[t]=e[t])}return o}const l=l=>{var{type:a="button",ref:u,disabled:s=!1,children:d,className:b,onClick:p,size:f="md",variant:O="outlined",color:g="primary",rounded:y=!1,leadingIcon:m,isLeadingIconSolid:j=!1,trailingIcon:v,isTrailingIconSolid:I=!1,badgeNumber:P="",needThrottle:S=!1}=l,h=c(l,["type","ref","disabled","children","className","onClick","size","variant","color","rounded","leadingIcon","isLeadingIconSolid","trailingIcon","isTrailingIconSolid","badgeNumber","needThrottle"]);
// eslint-disable-next-line no-undef
const w=r(void 0);return t((()=>()=>{w&&clearTimeout(w.current)}),[w]),/*#__PURE__*/e(n,i(function(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{},n=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(t).filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})))),n.forEach((function(r){o(e,r,t[r])}))}return e}({ref:u,size:f,type:a,disabled:s,rounded:y,color:g,variant:O,className:b,onClick:S?e=>{e.preventDefault(),w.current||(null==p||p(e),w.current=setTimeout((()=>{w.current=void 0}),300))}:p,leadingIcon:m,isLeadingIconSolid:j,trailingIcon:v,isTrailingIconSolid:I,badgeNumber:P},h),{children:d}))};export{l as Button};
